import { styled } from 'styled-components';


export default styled.div`
    padding: 6rem 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .icon{
        color: #c05858;
    }
    
    .text{
        text-align: center;
        font-family: var(--ftl);
        font-size: 2rem;
        color: #414141;
        margin-top: 1rem;

    }

`

